import QuinielazoService from "@/services/QuinielazoService";

export const namespaced = true;

export const state = {
	partidos: [],
	partido: {},
	partidos_disponibles: [],
	partidos_agregados: []
};

export const mutations = {
	SET_PARTIDOS(state, partidos) {
		state.partidos = partidos;
	},
	SET_PARTIDO(state, partido) {
		state.partido = partido
	},
	ADD_PARTIDO(state, partido) {
		state.partidos.data.push(partido)
	},
	SET_PARTIDOS_DISPONIBLES(state, partidos) {
		state.partidos_disponibles = partidos;
	},
	ADD_PARTIDOS_DISPONIBLES(state, partido) {
		state.partidos_disponibles.push(partido)
	},
	REMOVE_PARTIDOS_DISPONIBLES(state, partido) {
		state.partidos_disponibles = state.partidos_disponibles.filter(pdisponible =>
			pdisponible.id !== partido.id
		)
	},
	ADD_PARTIDOS_AGREGADOS(state, partido){
		if (!state.partidos_agregados.find(p => p.espn_id === partido.espn_id)){
			//Add
			state.partidos_agregados.push(partido)
		}else{
			//update
			for (var p in state.partidos_agregados) {
				if (state.partidos_agregados[p].espn_id == partido.espn_id) {
					this._vm.$set(state.partidos_agregados, p, partido)
					break;
				}
			}
		}
	},
	REMOVE_PARTIDOS_AGREGADOS(state, partido){
		state.partidos_agregados = state.partidos_agregados.filter(pagregado => 
			pagregado.espn_id !== partido.espn_id
		)
	}
};

export const actions = {
	fetchPartidos({ commit }, url = false) {
		QuinielazoService.getPartidos(url)
		.then(resp => {
			commit("SET_PARTIDOS", resp.data);
		})
		.catch(err => {
			console.log(err);
		});
	},
	fetchPartido({ commit, getters }, partido){
		var match = getters.getPartidoById(partido.id)
		if (match) {
			commit('SET_PARTIDO', match)
		}else{
			QuinielazoService.getPartido(partido.id)
			.then(resp => {
				commit('SET_PARTIDO', resp.data)
			})
			.catch(err => {
				console.log(err)
			});
		}
	},
	savePartido({ commit, dispatch }, partido){
		if (partido.id) {
			return QuinielazoService.updatePartido(partido)
			.then(resp => {
				commit('SET_PARTIDO', resp.data)
			})
			.catch(err => {
				dispatch("notification/add", {
					type: "error",
					message: "No se pudo guardar el partido: " + err.message
				}, { root: true });
				return err.response
			})
		}else{
			return QuinielazoService.postPartido(partido)
			.then(resp => {
				commit('ADD_PARTIDO', resp.data)
			})
			.catch(err => {
				dispatch("notification/add", {
					type: "error",
					message: "No se pudo guardar el partido: " + err.message
				}, { root: true });
				return err.response
			})
		}
	},
	fetchPartidosDisponibles({ commit }) {
		QuinielazoService.getPartidosDisponibles()
		.then(resp => {
			commit("SET_PARTIDOS_DISPONIBLES", resp.data);
		})
		.catch(err => {
			console.log(err);
		});
	},
	addpartido({commit}, partido){
		commit('ADD_PARTIDOS_DISPONIBLES', partido)
	},
	removepartido({commit}, partido){
		commit('REMOVE_PARTIDOS_DISPONIBLES', partido)
	},
	getEspn({dispatch}, args){
		return QuinielazoService.getEspn(args)
		.then(resp => {
			return resp.data
		})
		.catch(err => {
			dispatch('notification/add',{
				type: 'error',
				message: `No se pudieron cargar los partidos de ESPN ${err}`
			},{ root: true })
		})
	},
	getBot({ dispatch }, args) {
		return QuinielazoService.getBot(args)
			.then(resp => {
				return resp.data
			})
			.catch(err => {
				dispatch('notification/add', {
					type: 'error',
					message: `No se pudieron cargar los partidos de ESPN ${err}`
				}, { root: true })
			})
	}
};

export const getters = {
	getPartidoById: state => id => {
		return state.partidos.data.find(partido => partido.id === id);
	}
};
